export default __webpack_public_path__ + "static/media/info_cashout.min.2bfa17c2.png";